webpackJsonp([1],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(23)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(372),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24240b7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(23)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(371),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TemperatureGraph__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TemperatureGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TemperatureGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HumidityGraph__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HumidityGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_HumidityGraph__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/day'
  }, {
    path: '/:range',
    component: __WEBPACK_IMPORTED_MODULE_2__components_TemperatureGraph___default.a
  }, {
    path: '/humidity',
    redirect: '/humidity/day'
  }, {
    path: '/humidity/:range',
    component: __WEBPACK_IMPORTED_MODULE_3__components_HumidityGraph___default.a
  }]
}));

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(23)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(369),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(176);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(58);

//
//
//
//
//
//
//
//
//
//
//





// enumerating ECharts events for now
var ACTION_EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'focusnodeadjacency', 'unfocusnodeadjacency', 'brush', 'brushselected'];

var MOUSE_EVENTS = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousedown', 'mouseup', 'globalout'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: Object,
    theme: [String, Object],
    initOptions: Object,
    group: String,
    autoResize: Boolean,
    watchShallow: Boolean
  },
  data: function data() {
    return {
      chart: null
    };
  },

  computed: {
    // Only recalculated when accessed from JavaScript.
    // Won't update DOM on value change because getters
    // don't depend on reactive values
    width: {
      cache: false,
      get: function get() {
        return this.delegateGet('width', 'getWidth');
      }
    },
    height: {
      cache: false,
      get: function get() {
        return this.delegateGet('height', 'getHeight');
      }
    },
    isDisposed: {
      cache: false,
      get: function get() {
        return !!this.delegateGet('isDisposed', 'isDisposed');
      }
    },
    computedOptions: {
      cache: false,
      get: function get() {
        return this.delegateGet('computedOptions', 'getOption');
      }
    }
  },
  watch: {
    group: function group(_group) {
      this.chart.group = _group;
    }
  },
  methods: {
    // provide a explicit merge option method
    mergeOptions: function mergeOptions(options, notMerge, lazyUpdate) {
      this.delegateMethod('setOption', options, notMerge, lazyUpdate);
    },

    // just delegates ECharts methods to Vue component
    // use explicit params to reduce transpiled size for now
    resize: function resize(options) {
      this.delegateMethod('resize', options);
    },
    dispatchAction: function dispatchAction(payload) {
      this.delegateMethod('dispatchAction', payload);
    },
    convertToPixel: function convertToPixel(finder, value) {
      return this.delegateMethod('convertToPixel', finder, value);
    },
    convertFromPixel: function convertFromPixel(finder, value) {
      return this.delegateMethod('convertFromPixel', finder, value);
    },
    containPixel: function containPixel(finder, value) {
      return this.delegateMethod('containPixel', finder, value);
    },
    showLoading: function showLoading(type, options) {
      this.delegateMethod('showLoading', type, options);
    },
    hideLoading: function hideLoading() {
      this.delegateMethod('hideLoading');
    },
    getDataURL: function getDataURL(options) {
      return this.delegateMethod('getDataURL', options);
    },
    getConnectedDataURL: function getConnectedDataURL(options) {
      return this.delegateMethod('getConnectedDataURL', options);
    },
    clear: function clear() {
      this.delegateMethod('clear');
    },
    dispose: function dispose() {
      this.delegateMethod('dispose');
    },
    delegateMethod: function delegateMethod(name) {
      var _chart;

      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].util.warn('Cannot call [' + name + '] before the chart is initialized. Set prop [options] first.', this);
        return;
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_chart = this.chart)[name].apply(_chart, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args));
    },
    delegateGet: function delegateGet(name, method) {
      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].util.warn('Cannot get [' + name + '] before the chart is initialized. Set prop [options] first.', this);
      }
      return this.chart[method]();
    },
    init: function init() {
      var _this = this;

      if (this.chart) {
        return;
      }

      var chart = __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.init(this.$el, this.theme, this.initOptions);

      if (this.group) {
        chart.group = this.group;
      }

      chart.setOption(this.options, true);

      // expose ECharts events as custom events
      ACTION_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);
        });
      });
      MOUSE_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);

          // for backward compatibility, may remove in the future
          _this.$emit('chart' + event, params);
        });
      });

      if (this.autoResize) {
        this.__resizeHanlder = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
          chart.resize();
        }, 100, { leading: true });
        window.addEventListener('resize', this.__resizeHanlder);
      }

      this.chart = chart;
    },
    destroy: function destroy() {
      if (this.autoResize) {
        window.removeEventListener('resize', this.__resizeHanlder);
      }
      this.dispose();
      this.chart = null;
    },
    refresh: function refresh() {
      this.destroy();
      this.init();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$watch('options', function (options) {
      if (!_this2.chart && options) {
        _this2.init();
      } else {
        _this2.chart.setOption(_this2.options, true);
      }
    }, { deep: !this.watchShallow });

    var watched = ['theme', 'initOptions', 'autoResize', 'watchShallow'];
    watched.forEach(function (prop) {
      _this2.$watch(prop, function () {
        _this2.refresh();
      }, { deep: true });
    });
  },
  mounted: function mounted() {
    // auto init if `options` is already provided
    if (this.options) {
      this.init();
    }
  },
  activated: function activated() {
    if (this.autoResize) {
      this.chart && this.chart.resize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.destroy();
  },
  connect: function connect(group) {
    if (typeof group !== 'string') {
      group = group.map(function (chart) {
        return chart.chart;
      });
    }
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.connect(group);
  },
  disconnect: function disconnect(group) {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.disConnect(group);
  },
  registerMap: function registerMap() {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.registerMap.apply(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a, arguments);
  },
  registerTheme: function registerTheme() {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.registerTheme.apply(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a, arguments);
  }
});

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bulma_css_bulma_css__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bulma_css_bulma_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bulma_css_bulma_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TemperatureGraph__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TemperatureGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TemperatureGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppHeader__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppHeader__);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    TemperatureGraph: __WEBPACK_IMPORTED_MODULE_1__components_TemperatureGraph___default.a,
    AppHeader: __WEBPACK_IMPORTED_MODULE_2__components_AppHeader___default.a
  }
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_echarts_components_ECharts__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_echarts_components_ECharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_echarts_components_ECharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_lines__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_lines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_lines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_bar__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_chart_pie__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_map__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_chart_radar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_chart_radar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_echarts_lib_chart_radar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_chart_scatter__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_chart_scatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_echarts_lib_chart_scatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_echarts_lib_chart_effectScatter__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_echarts_lib_chart_effectScatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_echarts_lib_chart_effectScatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_echarts_lib_component_tooltip__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_echarts_lib_component_polar__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_echarts_lib_component_polar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_echarts_lib_component_polar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts_lib_component_geo__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts_lib_component_geo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_echarts_lib_component_geo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_echarts_lib_component_legend__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_echarts_lib_component_markLine__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_echarts_lib_component_markLine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_echarts_lib_component_markLine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_echarts_lib_component_markPoint__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_echarts_lib_component_markPoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_echarts_lib_component_markPoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_echarts_lib_component_title__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_visualMap__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_visualMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_visualMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HumidityRanges__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HumidityRanges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__HumidityRanges__);





//
//
//
//
//
//
//
//
//
//





















__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

var sensors = {
  'Büro': '1d003e000247343337373739', // Blue
  'Wohnzimmer': 'e00fce683ef6d5661611d84c', // Black
  'Schlafzimmer': '2d0021000347343233323032' // Red
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HumidityGraph',

  data: function data() {
    var sensorIds = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(sensors);
    var sensorData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(sensorIds.map(function (sensor) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, sensor, []);
    })));

    return {
      sensorData: sensorData
    };
  },

  components: {
    chart: __WEBPACK_IMPORTED_MODULE_6_vue_echarts_components_ECharts___default.a,
    HumidityRanges: __WEBPACK_IMPORTED_MODULE_23__HumidityRanges___default.a
  },

  computed: {
    sensorNames: function sensorNames() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sensors);
    },
    line: function line() {
      var _this = this;

      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              type: 'dashed'
            }
          },
          formatter: function formatter(points) {
            return [new Date(points[0].value[0]).toLocaleString('de-de').slice(0, -3)].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(points.map(function (point) {
              return [point.marker, point.seriesName, ': ', point.value[1]].join('');
            }))).join('<br>');
          }
        },
        legend: {
          data: this.sensorNames
        },
        grid: {
          show: false,
          left: '3%',
          right: '4%',
          bottom: '4%',
          top: '80px',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'time',
          offset: 15,
          boundaryGap: false,
          axisLabel: {
            textStyle: {
              color: '#669D95',
              fontWeight: 'bold'
            }
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          min: 'dataMin',
          type: 'value',
          offset: 15,
          axisLabel: {
            formatter: '{value} %',
            textStyle: {
              color: '#669D95',
              fontWeight: 'bold'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#D7F1ED'
            }
          }
        },
        series: this.sensorNames.map(function (sensorName) {
          return {
            name: sensorName,
            type: 'line',
            smooth: true,
            data: _this.sensorData[sensors[sensorName]],
            symbolSize: 7,
            hoverAnimation: false,
            markPoint: {
              data: [{ type: 'max', name: 'Höchsttemperatur' }, { type: 'min', name: 'Mindensttemperatur' }]
            },
            itemStyle: {
              normal: {
                borderWidth: 2
              }
            },
            lineStyle: {
              normal: {
                width: 4
              }
            }
          };
        })
      };
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$refs.humidityChart.showLoading();
    this.fetchHumidityData();
    setInterval(function () {
      _this2.fetchHumidityData();
    }, 10000);
  },


  watch: {
    '$route.path': function $routePath() {
      // this.$refs.humidityChart.showLoading()
      this.fetchHumidityData();
    }
  },

  methods: {
    sensorData: function sensorData(sensor) {
      return this[sensor];
    },
    updateSeries: function updateSeries() {
      var _this3 = this;

      this.line.series.map(function (serie, serieIndex) {
        serie.data = _this3.sensorData[sensors[serie.name]];
      });
    },
    fetchHumidityData: function fetchHumidityData() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://api.temperature.strebel.xyz/api/humidity/' + this.$route.params.range + '?api_token=Kr4DnHioPTjFxBKfohtH5JME9uHDudu6UL8vuUEjflhnQDAnjB9p8CavURyZ').then(function (_ref2) {
        var data = _ref2.data;

        data.map(function (data) {
          _this4.sensorData[data.sensor] = data.data;
        });

        _this4.$refs.humidityChart.hideLoading();
      });
    }
  }
});

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_echarts_components_ECharts__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_echarts_components_ECharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_echarts_components_ECharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_lines__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_lines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_lines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_bar__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_chart_pie__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_map__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_chart_radar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_chart_radar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_echarts_lib_chart_radar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_chart_scatter__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_chart_scatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_echarts_lib_chart_scatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_echarts_lib_chart_effectScatter__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_echarts_lib_chart_effectScatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_echarts_lib_chart_effectScatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_echarts_lib_component_tooltip__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_echarts_lib_component_polar__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_echarts_lib_component_polar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_echarts_lib_component_polar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts_lib_component_geo__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts_lib_component_geo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_echarts_lib_component_geo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_echarts_lib_component_legend__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_echarts_lib_component_markLine__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_echarts_lib_component_markLine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_echarts_lib_component_markLine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_echarts_lib_component_markPoint__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_echarts_lib_component_markPoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_echarts_lib_component_markPoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_echarts_lib_component_title__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_visualMap__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_visualMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_visualMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__TemperatureRanges__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__TemperatureRanges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__TemperatureRanges__);





//
//
//
//
//
//
//
//
//
//





















__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

var sensors = {
  'Büro': '1d003e000247343337373739', // Blue
  'Wohnzimmer': 'e00fce683ef6d5661611d84c', // Black
  'Schlafzimmer': '2d0021000347343233323032' // Red
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TemperatureGraph',

  data: function data() {
    var sensorIds = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(sensors);
    var sensorData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(sensorIds.map(function (sensor) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, sensor, []);
    })));

    return {
      sensorData: sensorData
    };
  },

  components: {
    chart: __WEBPACK_IMPORTED_MODULE_6_vue_echarts_components_ECharts___default.a,
    TemperatureRanges: __WEBPACK_IMPORTED_MODULE_23__TemperatureRanges___default.a
  },

  computed: {
    sensorNames: function sensorNames() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sensors);
    },
    line: function line() {
      var _this = this;

      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              type: 'dashed'
            }
          },
          formatter: function formatter(points) {
            return [new Date(points[0].value[0]).toLocaleString('de-de').slice(0, -3)].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(points.map(function (point) {
              return [point.marker, point.seriesName, ': ', point.value[1]].join('');
            }))).join('<br>');
          }
        },
        legend: {
          data: this.sensorNames
        },
        grid: {
          show: false,
          left: '3%',
          right: '4%',
          bottom: '4%',
          top: '80px',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'time',
          offset: 15,
          boundaryGap: false,
          axisLabel: {
            textStyle: {
              color: '#669D95',
              fontWeight: 'bold'
            }
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          min: 'dataMin',
          type: 'value',
          offset: 15,
          axisLabel: {
            formatter: '{value} °C',
            textStyle: {
              color: '#669D95',
              fontWeight: 'bold'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#D7F1ED'
            }
          }
        },
        series: this.sensorNames.map(function (sensorName) {
          return {
            name: sensorName,
            type: 'line',
            smooth: true,
            data: _this.sensorData[sensors[sensorName]],
            symbolSize: 7,
            hoverAnimation: false,
            markPoint: {
              data: [{ type: 'max', name: 'Höchsttemperatur' }, { type: 'min', name: 'Mindensttemperatur' }]
            },
            itemStyle: {
              normal: {
                borderWidth: 2
              }
            },
            lineStyle: {
              normal: {
                width: 4
              }
            }
          };
        })
      };
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$refs.temperatureChart.showLoading();
    this.fetchTemperatureData();
    setInterval(function () {
      _this2.fetchTemperatureData();
    }, 10000);
  },


  watch: {
    '$route.path': function $routePath() {
      // this.$refs.temperatureChart.showLoading()
      this.fetchTemperatureData();
    }
  },

  methods: {
    sensorData: function sensorData(sensor) {
      return this[sensor];
    },
    updateSeries: function updateSeries() {
      var _this3 = this;

      this.line.series.map(function (serie, serieIndex) {
        serie.data = _this3.sensorData[sensors[serie.name]];
      });
    },
    fetchTemperatureData: function fetchTemperatureData() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://api.temperature.strebel.xyz/api/temperature/' + this.$route.params.range + '?api_token=Kr4DnHioPTjFxBKfohtH5JME9uHDudu6UL8vuUEjflhnQDAnjB9p8CavURyZ').then(function (_ref2) {
        var data = _ref2.data;

        data.map(function (data) {
          _this4.sensorData[data.sensor] = data.data;
        });

        _this4.$refs.temperatureChart.hideLoading();
      });
    }
  }
});

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4IDQ4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0OCA0OCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIGZpbGw9IiNFOEVBRjYiIGQ9Ik00MSw0Mkg5VjIwLjk0NUwyNS4wNTEsOS4xODRMNDEsMjAuNDg0VjQyeiI+PC9wYXRoPgo8cGF0aCBmaWxsPSIjREQyQzAwIiBkPSJNNDMsMjVMMjUsMTIuOTUzTDcsMjV2LTdMMjUsNmwwLDBsMTgsMTJWMjV6Ij48L3BhdGg+CjxyZWN0IHg9IjkiIHk9IjM3IiBmaWxsPSIjQzVDQUU5IiB3aWR0aD0iMzIiIGhlaWdodD0iNSI+PC9yZWN0Pgo8cGF0aCBmaWxsPSIjRkYzRDAwIiBkPSJNMjcsMjcuNTU1VjIwYzAtMS4xLTAuOS0yLTItMnMtMiwwLjktMiwydjcuNTU1Yy0xLjE5LDAuNjkzLTIsMS45NjktMiwzLjQ0NWMwLDIuMjA4LDEuNzkyLDQsNCw0CglzNC0xLjc5Miw0LTRDMjksMjkuNTI0LDI4LjE5LDI4LjI0OCwyNywyNy41NTV6Ij48L3BhdGg+CjxwYXRoIGZpbGw9IiM5RkE4REEiIGQ9Ik0yNywyMWgzdjJoLTNWMjF6IE0yNywyNmgzdi0yaC0zVjI2eiI+PC9wYXRoPgo8L3N2Zz4K"

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(23)(
  /* script */
  null,
  /* template */
  __webpack_require__(374),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(23)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(370),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17b73138",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(23)(
  /* script */
  null,
  /* template */
  __webpack_require__(375),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(23)(
  /* script */
  null,
  /* template */
  __webpack_require__(373),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 369:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n    Humidity Graph\n  ")]), _vm._v(" "), _c('humidity-ranges'), _vm._v(" "), _c('chart', {
    ref: "humidityChart",
    attrs: {
      "options": _vm.line
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts"
  })
},staticRenderFns: []}

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n    Temperature Graph\n  ")]), _vm._v(" "), _c('temperature-ranges'), _vm._v(" "), _c('chart', {
    ref: "temperatureChart",
    attrs: {
      "options": _vm.line
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-toggle is-centered"
  }, [_c('ul', [_c('router-link', {
    attrs: {
      "to": "/hour",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Hour")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/day",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Day")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/week",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Week")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/month",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Month")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/year",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Year")])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-vcentered is-centered has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n            Temperature\n          ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n            Temperature & Humidity in my home\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('router-link', {
    staticClass: "button is-white",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Temperature")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-white",
    attrs: {
      "to": "/humidity/day"
    }
  }, [_vm._v("Humidity")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-narrow"
  }, [_c('img', {
    staticClass: "app-logo",
    attrs: {
      "src": __webpack_require__(364)
    }
  })])
}]}

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-toggle is-centered"
  }, [_c('ul', [_c('router-link', {
    attrs: {
      "to": "/humidity/hour",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Hour")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/humidity/day",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Day")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/humidity/week",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Week")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/humidity/month",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Month")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/humidity/year",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Year")])])], 1)])
},staticRenderFns: []}

/***/ })

},[195]);


// WEBPACK FOOTER //
// static/js/app.11140cd98725a63ad399.js